import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import defaultimg from '../../../assets/defaultimg.webp';
import './editprojectmembers.css';

const EditProjectMembers = ({ projectmembers, pendingInvitations, handleDeleteMember, handleCancelInvitation }) => {
  return (
    <div style={{ marginTop: '1.5rem' }}>
      {projectmembers && projectmembers.length > 0 ? (
        <div>
          {projectmembers.map((member) => (
            <div key={member.project_member_id}>
              <div className="projmember">
                <div className="projmember-column1">
                  <div className="membersImg">
                    {/* Check if users array exists and has items */}
                    <img 
                      src={(member.users && member.users[0] && member.users[0].profile_pic) || defaultimg} 
                      alt="Profile"
                      className="membersImg2"
                    />
                  </div>
                </div>
                <div className="projmember-column2">
                  <div>
                    {/* Access user information with proper checks */}
                    {member.users && member.users[0] ? (
                      `${member.users[0].first_name} ${member.users[0].last_name}`
                    ) : (
                      "Unknown User"
                    )}
                    <button 
                      className='projmemberdelbtn' 
                      onClick={() => handleDeleteMember(member.project_member_id)}
                    >
                      <i className="fa-solid fa-trash"></i>
                    </button>
                    <span style={{ float: 'right', fontWeight: '300' }}>({member.role})</span>
                  </div>
                  
                  {/* Only render this section if user data exists */}
                  {member.users && member.users[0] && (
                    <>
                      <div>
                        <p style={{ fontWeight: '300', margin: '0.5rem 0' }}>
                          {member.users[0].course}
                          {member.users[0].mat_year ? ` Y${member.users[0].mat_year}` : ''}
                        </p>
                      </div>
                      <div className="projmemberdesc">
                        {member.users[0].description || 'No description available'}
                      </div>
                      <div>
                        <RouterLink 
                          to={`/user/${member.users[0].user_id}`} 
                          className="teambtn"
                        >
                          View &gt;
                        </RouterLink>
                      </div>
                    </>
                  )}
                </div>
              </div>
              <hr />
            </div>
          ))}
        </div>
      ) : (
        <div>
          <span>No Members Added</span>
        </div>
      )}

      {/* Display pending invitations if available */}
      {pendingInvitations && pendingInvitations.length > 0 && (
        <div style={{ marginTop: '1.5rem' }}>
          <h3 style={{ fontWeight: '500' }}>Pending Invitations</h3>
          {pendingInvitations.map((invitation) => (
            <div key={invitation.invitation_id} style={{ border: '1px solid #e2e8f0', padding: '0.75rem', marginBottom: '0.5rem', borderRadius: '0.25rem' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <p style={{ fontWeight: '500' }}>
                    {invitation.invitee?.first_name} {invitation.invitee?.last_name} 
                    <span style={{ fontSize: '0.875rem', fontWeight: '300', marginLeft: '0.5rem' }}>({invitation.role})</span>
                  </p>
                  <p style={{ fontSize: '0.875rem', color: '#718096' }}>
                    Invited by {invitation.inviter?.first_name} {invitation.inviter?.last_name} on {new Date(invitation.invited_at).toLocaleDateString()}
                  </p>
                </div>
                <button 
                  style={{ color: '#e53e3e', cursor: 'pointer', background: 'none', border: 'none' }}
                  onClick={() => handleCancelInvitation(invitation.invitation_id)}
                >
                  Cancel
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default EditProjectMembers;